export default "__VITE_ASSET__8c583f79__"